import React from "react";
import StaffSidebar from "./StaffSidebar";
import { Outlet } from "react-router-dom";

const StaffLayout: React.FC = () => (
  <div className="flex">
    <StaffSidebar />
    <div className="flex-1 p-6">
      <Outlet />
    </div>
  </div>
);

export default StaffLayout;
